
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/baby-face-generator",
      function () {
        return require("private-next-pages/baby-face-generator/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/baby-face-generator"])
      });
    }
  